<template>
<div class="main">
    
    <div>
        <DiamondQuizTitle @closePage="emitclosePage"/>
    </div>

    <div  class="for_scroll" ref="scrollContainer" v-if="items.length && !showGemologistForm">
        <div class="mt-3 loose_data"  v-for="item in items.slice(0, 4)" :key="item.id" >
            <NuxtLink :to="localePath(detailPath(item.slug))">
                <div class="diam_box">
                    <div class="box1">
                        <img width="703" height="703" :src="item.diamond_thumb_image" alt="Diamond Items" />
                    </div>
                    <div class="detail_box">
                        <p class="name">{{ item.carat }} Carat {{ item.shape }} Lab Diamond</p>
                        <p class="type"> {{ item.color }} <span class="pipe">|</span> {{ item.clarity }} <span class="pipe">|</span> {{ item.cut }} <span class="pipe">|</span>{{ item.lab }}</p>
                        <div class="pnw">
                        <p class="price">{{ $formatPrice(item.price) }}</p>
                        </div>
                    </div>
                </div>
            </NuxtLink>
        </div>
    </div>

    <div v-if="!showGemologistForm && items.length === '0'">
        <p class="text-center">No Result Found!</p>
    </div>

    <!-- <div class="gemo" v-if="showGemologistForm">
        <GemologistForm  quiz="result" />
    </div> -->

    <div>
        <div class="wrapper" :class="{'wrapper_mmod' : showGemologistForm}" v-if="items.length">
            <div class="btn_wrap" @click="showMoreResult" v-if="!showGemologistForm">
                <div class="button text-center">
                    <span>show more</span>
                </div>
            </div>
            <!-- <div class="help" :class="{'help_mod':showGemologistForm}">
                <p>Need Help? <br> <span  @click="toggleGemologistForm">Consult our Gemologist </span> </p>
            </div> -->
        </div>
        <DiamondQuizFooter />
    </div>

</div>

</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const {$formatPrice} = useNuxtApp()
const router = useRouter()
const store = diamondQuizStore()

const emit = defineEmits(['close'])

const items = ref([])

const localePath = useLocalePath();

const moduleSubType = inject('moduleSubType');

const scrollContainer = ref('')
const isDown = ref(null)
const startX = ref(null)
const scrollLeft = ref(null)

const showGemologistForm = ref(false)

const toggleGemologistForm = () => {
    showGemologistForm.value = !showGemologistForm.value
}

const emitclosePage = () => {
    emit('close')
}

const showMoreResult = () =>{
    const baseUrl = window.location.origin + window.location.pathname;

    // Convert the params object to a query string
    const queryString = new URLSearchParams(store.getPayload).toString();

    // Set the new URL with query parameters
    window.location.href = `${baseUrl}?${queryString}`;
}



const detailPath = (slug) => {
    if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {
        return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug } };
    }
    return { name: 'loose-detail', params: { slug } };
};


function initHorizontalScroll() {
      const scrollContainerDiv = scrollContainer.value;
      if (scrollContainerDiv) {
          scrollContainerDiv.addEventListener('mousedown', (e) => {
              isDown.value = true;
              startX.value = e.pageX - scrollContainerDiv.offsetLeft;
              scrollLeft.value = scrollContainerDiv.scrollLeft;
          });

          scrollContainerDiv.addEventListener('mouseleave', () => {
              isDown.value = false;
          });

          scrollContainerDiv.addEventListener('mouseup', () => {
              isDown.value = false;
          });

          scrollContainerDiv.addEventListener('mousemove', (e) => {
              if (!isDown.value) return;
              e.preventDefault();
              const x = e.pageX - scrollContainerDiv.offsetLeft;
              const walk = (x - startX.value) * 2; // Adjust scrolling speed here
              scrollContainerDiv.scrollLeft = scrollLeft.value - walk;
          });
      }
}


onMounted(() => {
    initHorizontalScroll();
    items.value = store.getResult;  
    console.log(items.value, 'itemsssssss');   
})

</script>

<style scoped>
/* .main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
} */
.gemo {
    max-width: 400px;
    margin: 0 auto;
}

::-webkit-scrollbar {
  width: 2px;
  height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f5f5f5; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #c4c4c4;   
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c4c4c4; 
}

br{
    display: none;
}

/* looosoe copy  */
/* .loose_block{
    display: flex;
  } */
  /* .loose_data{
    margin-right: 16px;
  } */
  .loose_data:last-child{
    margin-right: 0;
  }
  
.diam_box{
  position: relative;
  height: auto;
  /* min-width: 225px; */
  max-width: 200px;
  /* border-radius: 8px; */
  cursor: pointer;
}

.diam_box .box1 img {
    min-height: 180px;
    object-fit: cover;
    max-height: 180px;
    width: 100%;
}

.for_scroll {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  padding-bottom: 5px;
  cursor: pointer;
  justify-content: center;
  gap: 16px;
  /* margin-bottom: 7%; */
 
}


/* .no_scroll {
  overflow-x: hidden;
} */



.box1 img{
    object-fit: cover;
    max-height: 180px;
    width: 100%;
    border-radius: 8px 8px 0 0;
}

.detail_box {
    background: #ffffff;
    padding: 16px 12px;
    border-radius: 0 0 8px 8px;
}

.detail_box .type{
    font-size: 14px;
    color: #353535;
    margin-bottom: 12px;
    font-weight: 500;
    text-transform: uppercase;
}

.detail_box .name{
    font-size: 14px;
    color: #353535;
    margin-bottom: 8px;
    font-weight: 600;
}

.price{
    font-size: 16px;
    color: var(--green);
    font-weight: 600;
    margin: 0;
}

.pnw {
    display: flex;
    justify-content: space-between;
}
.back {
    position: absolute;
    top: 12px;
    left: 12px;
    cursor: pointer;
}

.largeBack {
    transform: scale(1.5)
}

.button {
    padding: 14px 30px;
    border: 1.5px solid #212529;
    border-radius: 4px;
    width: 40%;
    margin: 0 auto;
    margin-bottom: 12px;
    cursor: pointer;
    
}

.button span {
    font-size: 14px;
    font-weight: 700;
    color: #353535;
    text-transform: uppercase;
    letter-spacing: 1px;
    
}

.help {
    font-size: 14px;
    text-align: center;
}

.help p {
    color: #353535;
}

.help span {
    color: var(--green);
    text-decoration: underline;
    cursor: pointer;
}

.wrapper {
    display: flex;
    flex-direction: column;
}


@media(max-width:992px){
    .button {
        width: 60%;
        padding: 10px 15px;
    }
    .diam_box{
        min-width: 160px;
    }
    .for_scroll {
        justify-content: flex-start;
    }
}

@media(max-width:768px) {
    br{
        display: block;
    }
    
    .button {
        width: 100%;
        margin: 0;
        
    }

    .wrapper{
        flex-direction: row-reverse;
        /* justify-content: space-between; */
        justify-content: center;
        align-items: center;
        /* padding: 0 10px; */
        width: 100%;
    }

    .wrapper_mmod {
        flex-direction: column;
    }

    .btn_wrap {
        width: 96%;
    }

    .help {
        text-align: left;
        margin-top: 5px;
        width: 50%;
    }
    
    .box{
        margin: 10px 0 0 ;
    }
    .detail_box{
        font-size: 14px
    }
    .main {
        height: auto;
    }
    .for_scroll {
        margin-bottom: 2%;
    }

    .help_mod {
        width: 100%;
    }

    .help_mod br {
        display: none;
    }

    .help_mod p {
        text-align: center;
    }
    
}

@media(max-width:576px){
    .diam_box{
        min-width: 150px;
    }
}

@media(max-width:500px) {
    .gemo {
        padding: 10px;
    }
}



</style>